import { FC } from 'react';
import { PatternFormat } from 'react-number-format';
import styles from './InputMask.module.scss';
import classNames from 'classnames';
import { setErrorStatusField, setNotErrorStatusField } from 'redux/mainInfo/slice';
import { useDispatch } from 'react-redux';

type InputTextProps = {
  placeholder: string;
  value: string;
  setValue: (s: string) => void;
  type?: 'tel' | 'number';
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  error?: boolean;
  inputMaskRef?: React.RefObject<HTMLInputElement>;
  appStatus?: number;
  nameError?: string;
  isModerated?: boolean;
  width?: boolean;
  disabled?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
};

export const InputMask: FC<InputTextProps> = ({
  value,
  setValue,
  placeholder,
  type,
  onKeyDown,
  error,
  inputMaskRef,
  appStatus,
  nameError,
  isModerated = false,
  width,
  disabled = true,
  onBlur,
}) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.rootPhone}>
      <PatternFormat
        disabled={disabled}
        getInputRef={inputMaskRef}
        onKeyDown={onKeyDown}
        placeholder={type === 'number' ? 'xxx-xxx' : ''}
        className={classNames(
          styles.tel,
          error ? styles.telError : '',
          type === 'tel' && appStatus ? styles.telStatus : '',
          width ? styles.tel_width : '',
        )}
        format={
          type === 'tel'
            ? value?.length === 11
              ? '+# (###) ###-##-##'
              : '+7 (###) ###-##-##'
            : '###-###'
        }
        value={value}
        valueIsNumericString={true}
        onBlur={onBlur}
        onValueChange={(values) => {
          setValue(values.value);
          if (values.value.length < 10) {
            dispatch(setErrorStatusField(nameError));
          } else {
            dispatch(setNotErrorStatusField(nameError));
          }
        }}
      />
      <span
        style={isModerated ? { background: 'transparent' } : {}}
        className={classNames(
          styles.placeholder,
          (type === 'number' || value) && styles.placeholder_active,
          error ? styles.placeholderError : '',
          type === 'tel' && appStatus ? styles.placeholderStatus : '',
        )}>
        {placeholder}
      </span>
    </div>
  );
};
